import { Navigate, Outlet } from 'react-router'
import { useEffect } from 'react'
import { useAuthStore } from './store/authStore'
import { useIdentify } from '@/hooks/posthog/useIdentify'

export const ProtectedRoute = () => {
  const { session, user } = useAuthStore()

  const { identifyUser, isAlreadyIdentified } = useIdentify()

  useEffect(() => {
    if (!user) return
    if (isAlreadyIdentified(user)) return
    identifyUser(user)
  }, [identifyUser, isAlreadyIdentified, user])

  return session?.access_token ? <Outlet /> : <Navigate to='/auth/login' />
}
